export default __webpack_public_path__ + "static/media/858.01336151.gif";